import React from 'react'
import { useSelector } from 'react-redux';
import { liveTrackinglayoutSelector } from '../features/layout/layoutSlice';

import SubAccountTop from '../components/subaccounts/SubAccountTop';
import SubAccountListView from '../components/subaccounts/SubAccountListView';
//import SubAccountPaginate from '../components/subaccounts/SubAccountPaginate';
import SubAccountMainView from '../components/subaccounts/SubAccountMainView';

const SubAccountView = () => {
    const dimentions = useSelector(liveTrackinglayoutSelector);
    return (
        <div style={dimentions.sidebar}>
            <div style={dimentions.subAccountBarTop}>
                <SubAccountTop />
            </div>
            <div style={{ ...dimentions.subAccountBarBottom, overflow: 'auto' }}>
                <SubAccountListView />
            </div>
            <div style={{ ...dimentions.subAccountDetailView, overflow: 'auto' }}>
                <SubAccountMainView />
            </div>
        </div>
    );
}

export default SubAccountView;

